<template>
  <div id="childrenEducationfinanceTable">
    <!-- 条件查询 -->
    <div class="searchForm">
      <el-form :model="depositPrdDTO" inline ref="searchForm">
        <el-form-item label="产品代码" prop="prdCode" class="search-ipt">
          <el-input v-model.trim="depositPrdDTO.prdCode" size="small" placeholder="请输入产品代码" />
        </el-form-item>
        <el-form-item label="产品名称" prop="prdName" class="search-ipt">
          <el-input v-model.trim="depositPrdDTO.prdName" size="small" placeholder="请输入产品名称" />
        </el-form-item>
        <el-form-item label="产品状态" prop="saleStatus" class="search-ipt">
          <el-select v-model="depositPrdDTO.saleStatus" size="small" placeholder="请选择">
            <el-option label="全部" value="" />
              <el-option key="1" label="在售" value="1" />
              <el-option key="2" label="停售" value="2" />
              <el-option key="3" label="售罄" value="3" />
          </el-select>
        </el-form-item>
        <el-form-item label="存单期限" prop="termLimit" class="search-ipt">
          <el-select v-model="depositPrdDTO.termLimit" size="small" placeholder="请选择存单期限">
            <el-option label="全部" value="" />
            <el-option key="1" label="1个月" value="1" />
            <el-option key="2" label="3个月" value="2" />
            <el-option key="3" label="6个月" value="3" />
            <el-option key="4" label="9个月" value="4" />
            <el-option key="5" label="1年" value="5" />
            <el-option key="6" label="18个月" value="6" />
            <el-option key="7" label="2年" value="7" />
            <el-option key="8" label="3年" value="8" />
            <el-option key="9" label="5年" value="9" />
          </el-select>
        </el-form-item>
        <el-form-item label="年利率ㅤ" class="search-ipt">
          <el-col :span="11">
            <el-form-item prop="annualInsrateFloor" class="search-ipt" style="margin-right:0px;">
              <el-input placeholder="下限值" v-model.number="depositPrdDTO.annualInsrateFloor" />
            </el-form-item>
          </el-col>
          <el-col :span="2" style="text-align:center">
            <span style="color:#999999">—</span>
          </el-col>
          <el-col :span="11">
            <el-form-item prop="annualInsrateCeiling" class="search-ipt">
              <el-input placeholder="上限值" v-model.number="depositPrdDTO.annualInsrateCeiling" />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="是否置顶" prop="isTop" class="search-ipt">
          <el-select v-model="depositPrdDTO.isTop" size="small" placeholder="请选择是否置顶">
            <el-option label="全部" value="" />
            <el-option key="1" label="是" value="1" />
            <el-option key="0" label="否" value="0" />
          </el-select>
        </el-form-item>
        <el-form-item label="上下架状态" prop="isSale" class="search-ipt">
          <el-select v-model="depositPrdDTO.isSale" size="small" placeholder="请选择上下架状态">
            <el-option label="全部" value="" />
            <el-option key="1" label="上架" value="1" />
            <el-option key="0" label="下架" value="0" />
          </el-select>
        </el-form-item>
        <br />
        <el-form-item class="search-ipt">
          <el-button size="small" @click="reset">清空</el-button>
          <el-button size="small" type="primary" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 产品列表 -->
    <div class="prdList">
      <el-table ref="multipleTable" class="prdTable" :data="tableData" :header-cell-style="{ background: '#F5F7FA' }" tooltip-effect="dark">
        <template slot="empty">
          <p style="position:relative;left:-530px">{{ emptyText }}</p>
        </template>
        <el-table-column label="选中" fixed="left" width="50" align="center">
          <template slot-scope="scope">
            <el-checkbox v-model="scope.row.checked" @change="singleAddPrd(scope.row)" />
          </template>
        </el-table-column>
        <el-table-column prop="prdCode" label="产品代码" fixed="left" width="100" align="center">
          <template slot-scope="scope">
            <span v-if="functionList.indexOf('322545212274216960') == '-1'" class="productDecoration" @click="getDepositDetail(scope.row)" v-html="scope.row.prdCode" />
            <span v-else v-html="scope.row.prdCode" />
          </template>
        </el-table-column>
        <el-table-column prop="prdName" label="产品名称" fixed="left" width="150" align="center" />
        <el-table-column prop="saleStatus" label="产品状态" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.saleStatus === '停售' || scope.row.saleStatus === '售罄'" style="color:#a2a7b3">{{ scope.row.saleStatus }}</span>
            <span v-if="scope.row.saleStatus !== '停售' && scope.row.saleStatus !== '售罄'">{{ scope.row.saleStatus }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="isSale" label="上下架状态" width="100" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.isSale === '下架'" style="color:#a2a7b3">{{ scope.row.isSale }}</span>
            <span v-if="scope.row.isSale !== '下架'">{{ scope.row.isSale }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="isTop" label="是否置顶" align="center" />
        <el-table-column prop="termLimit" label="存单期限" width="130" align="center" />
        <el-table-column prop="annualInsrate" label="年利率" width="150" align="center" >
          <template slot-scope="scope">
            {{ scope.row.annualInsrate}}%
          </template>
        </el-table-column>
        <el-table-column prop="interestType" label="计息方式" width="150" align="center" />
        <el-table-column prop="payIntType" label="付息方式" width="150" align="center" />
        <el-table-column label="递增金额(元)" width="100" align="center">
          <template slot-scope="scope">
            {{ scope.row.incrementalAmount | addMoneyFilter }}
          </template>
        </el-table-column>
        <el-table-column label="单笔最高限额(元)" width="130" align="center">
          <template slot-scope="scope">
            {{ scope.row.perBuyMaxMoney | addMoneyFilter }}
          </template>
        </el-table-column>
        <el-table-column label="单人最高限额(元)" width="130" align="center">
          <template slot-scope="scope">
            {{ scope.row.onePerBuyMaxMoney | addMoneyFilter }}
          </template>
        </el-table-column>
        <el-table-column label="发售总额(元)" width="130" align="center">
          <template slot-scope="scope">
            {{ scope.row.saleAmt | addMoneyFilter }}
          </template>
        </el-table-column>
        <el-table-column label="起存金额(元)" width="130" align="center">
          <template slot-scope="scope">
            {{ scope.row.originBuyMoney | addMoneyFilter }}
          </template>
        </el-table-column>
        <el-table-column label="可售余额(元)" width="100" align="center">
          <template slot-scope="scope">
            {{ scope.row.remainAmounts | addMoneyFilter }}
          </template>
        </el-table-column>
        <el-table-column prop="isAdvWithdraw" label="是否提前支取" width="120" align="center" />
        <el-table-column prop="advWithdrawNumber" label="可提前支取次数" width="120" align="center" />
        <el-table-column prop="currencyType" label="币种" width="130" align="center" />
      </el-table>
      <el-row>
        <el-col :span="4">
          <div class="warnText" v-if="tenPrdsFlag">已选产品不能超过10个</div>
          &emsp;
        </el-col>
        <el-col :span="20">
          <yh-pagination :page.sync="currentPage" :limit="pageSize" :total="sumCount" style="padding-top:0px" />
        </el-col>
      </el-row>
    </div>
    <!--产品详情-->
    <depositDetailDialog ref="depositDetailDialog" />
  </div>
</template>

<script>
import depositDetailDialog from '../../../../components/wpsp/productPlan/depositDetailDialog';
import { getFunctionList } from '@/mixins';

export default {
  name: 'depositTable',
  mixins: [getFunctionList],
  components: {
    depositDetailDialog,
  },
  props: {
    selectedTags: Array,
  },
  data() {
    return {
      emptyText: this.$LS.empty,
      currentPage: 1,
      pageNo: 1,
      pageSize: 5,
      sumCount: 0,
      functionList: [],
      financePrdDTO: {
        token: JSON.parse(sessionStorage.getItem('userToken')),
        prdName: '',
        prdCode: '',
        saleStatus: '',
        annualInsrateStart: '',
        annualInsrateEnd: '',
        termLimit: '',
        isTop: '',
        isSale: '',
        userId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
        orgnCode: JSON.parse(sessionStorage.getItem('sessionData')).orgnCode,
        orgnInheritSign: JSON.parse(sessionStorage.getItem('sessionData')).orgnInheritSign,
      },
      depositPrdDTO: {
        token: JSON.parse(sessionStorage.getItem('userToken')),
        prdName: '',
        prdCode: '',
        saleStatus: '',
        annualInsrateFloor: '',
        annualInsrateCeiling: '',
        termLimit: '',
        isTop: '',
        isSale: '',
        userId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
        orgnCode: JSON.parse(sessionStorage.getItem('sessionData')).orgnCode,
        orgnInheritSign: JSON.parse(sessionStorage.getItem('sessionData')).orgnInheritSign,
      },
      tableData: [],
      multipleSelection: [],
      tmpTag: [],
      prdDetailVisible: false,
      tenPrdsFlag: false,
    };
  },
  watch: {
    currentPage() {
      this.getTableData();
    },
    // 监听已选列表长度，不超过10个就将错误提示隐藏
    selectedTags(val) {
      if (val.length <= 10) {
        this.tenPrdsFlag = false;
      }
    },
  },
  methods: {
    // 查询按钮
    search() {
      this.currentPage = 1;
      this.pageNo = 1;
      this.getTableData();
    },
    reset() {
      Object.keys(this.depositPrdDTO).forEach((key) => {
        this.financePrdDTO[key] = '';
        this.depositPrdDTO[key] = '';
      });
      this.financePrdDTO.token = JSON.parse(sessionStorage.getItem('userToken'));
      this.financePrdDTO.userId = JSON.parse(sessionStorage.getItem('sessionData')).userId;
      this.financePrdDTO.orgnCode = JSON.parse(sessionStorage.getItem('sessionData')).orgnCode;
      this.financePrdDTO.orgnInheritSign = JSON.parse(sessionStorage.getItem('sessionData')).orgnInheritSign;
      this.depositPrdDTO.token = JSON.parse(sessionStorage.getItem('userToken'));
      this.depositPrdDTO.userId = JSON.parse(sessionStorage.getItem('sessionData')).userId;
      this.depositPrdDTO.orgnCode = JSON.parse(sessionStorage.getItem('sessionData')).orgnCode;
      this.depositPrdDTO.orgnInheritSign = JSON.parse(sessionStorage.getItem('sessionData')).orgnInheritSign;
    },
    // 新增===》单选产品
    singleAddPrd(row) {
      const tagVal = {
        prdId: row.id,
        prdName: row.prdName,
        prdCode: row.prdCode,
        prdType: '2',
        addFlag: '1',
        addTime: this.formatTime(new Date()),
      };
      // 如果checked为false并且标记为true，则说明该产品因为超过10个产品而checked值被手动改为false。这里手动改为true并将标记置空，解决了超过10个产品后，取消选择一个产品，再选择该产品无法选择的问题。
      if (row.checked === false && row.passed === true) {
        row.checked = true;
        row.passed = undefined;
      }
      if (row.checked) {
        if (this.selectedTags.length === 10) {
          row.checked = false;
          row.passed = true;
          this.tenPrdsFlag = true;
          return false;
        }
        this.selectedTags.push(tagVal);
        return true;
      }
      for (let index = 0; index < this.selectedTags.length; index++) {
        const element = this.selectedTags[index];
        if (element.id === tagVal.id || (element.prdName === tagVal.prdName && element.prdType === tagVal.prdType)) {
          this.selectedTags.splice(index, 1);
          break;
        }
      }
    },
    // 理财产品列表查询
    getTableData() {
      this.emptyText = this.$LS.loading;
      const parames = {
        data: {
          financePrdDTO: this.financePrdDTO,
          depositPrdDTO: this.depositPrdDTO,
          productType: '2',
        },
        pageMessage: {
          pageSize: this.pageSize || 5,
          pageNo: this.currentPage,
        },
      };
      this.$_post(this.$API.getDepositList, parames)
        .then((res) => {
          this.emptyText = this.$LS.emptySearch;
          this.tenPrdsFlag = false;
          const { list } = res.data;
          // 如果没有选择任何产品则取消所有勾
          if (this.selectedTags.length === 0) {
            for (let index = 0; index < list.length; index++) {
              list[index].checked = false;
            }
          }
          for (let j = 0; j < list.length; j++) {
            const product = list[j];
            for (let i = 0; i < this.selectedTags.length; i++) {
              const element = this.selectedTags[i];
              // prdType、prdCode确定一条数据
              if (product.prdCode === element.prdCode) {
                product.checked = true;
                break;
              } else {
                product.checked = false;
              }
            }
          }
          this.tableData = list;
          this.sumCount = res.sumCount;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 理财产品详情查询
    getDepositDetail(row) {
      this.$refs.depositDetailDialog.getDepositDetail(row.id);
    },
  },
};
</script>
<style lang="scss" scoped>
#childrenEducationfinanceTable {
  .search-ipt {
    margin-bottom: 0px;
  }
  .prdTable {
    width: 100%;
    border: 1px solid #f5f7fa;
  }
  .productDecoration {
    border-bottom: 1px solid #1e88ff;
    color: #1e88ff;
    cursor: pointer;
  }
  .warnText {
    color: red;
    font-size: 12px;
  }
}
</style>
